export default "__VITE_ASSET__DNfn7EnP__"